(function (angular) {
    'use strict';

    angular.module('shared')
        .controller('TOTPCtrl', ['jwtService', 'totpService', '$scope', '$stateParams', '$state', 'totpStatus',
            function (jwtService, totpService, $scope, $stateParams, $state, totpStatus) {
                $scope.qrCodeVisible = false;
                $scope.qrCodeImageSrc = '';
                $scope.user = { authCode: '' };
                $scope.accountId = $stateParams.accountId;
                $scope.userId = $stateParams.userId;
                $scope.returnUrl = $stateParams.returnUrl
                $scope.isInvalidAuthCode;
                $scope.idsBag = {
                    accountId: $scope.accountId,
                    userId: $scope.userId
                };

                $scope.submitAction = function () {
                    if ($scope.qrCodeVisible) {
                        $scope.enroll($scope.idsBag, $scope.user.authCode);
                    } else {
                        $scope.validate($scope.idsBag, $scope.user.authCode);
                    }
                };

                $scope.enroll = function (idsBag, authCode) {
                    $scope.isInvalidAuthCode = false;
                    totpService.verifyTotp(idsBag, authCode)
                        .then(function (response) {
                            if (response.data.token) {
                                $scope.handleSuccessfulValidation(response);
                            } else {
                                $scope.isInvalidAuthCode = true;
                            }
                        })
                };

                $scope.validate = function (idsBag, authCode) {
                    $scope.isInvalidAuthCode = false;
                    totpService.verifyTotp(idsBag, authCode)
                    .then(function (response) {
                        if (response.data.token) {
                            $scope.handleSuccessfulValidation(response);
                        } else {
                            $scope.isInvalidAuthCode = true;
                        }
                    })
                };

                $scope.handleSuccessfulValidation = function(response) {
                    jwtService.loginComplete(response);

                    if ($scope.returnUrl) {
                        jwtService.silentLogOnJwt($scope.returnUrl);
                    } else {
                        $state.go('main.home');
                    }
                  };

                $scope.$on('$viewContentLoaded', function () {
                    totpService.getTotpStatus($scope.idsBag)
                        .then(function (result) {
                            if (totpStatus[result.totpStatus] === totpStatus.Enrolling) {
                                totpService.generateTotp($scope.idsBag)
                                    .then(function (result) {
                                        $scope.qrCodeImageSrc = result.bitMapSource;
                                        $scope.qrCodeVisible = true;
                                    })
                            }
                        });

                });

            }]);

})(window.angular);